module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/babel-runtime/core-js/get-iterator.js
// module id = 751
// module chunks = 0